import posthog from "posthog-js";

/**
 * Só há PostHog no browser, com a chave configurada e depois do `init`.
 * O `__loaded` importa: sem consentimento o provider não inicializa, e chamar
 * `capture` antes disso só geraria ruído no console.
 */
const isEnabled = (): boolean =>
  typeof window !== "undefined" &&
  Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY) &&
  Boolean(posthog.__loaded);

export function track(event: string, properties?: Record<string, unknown>): void {
  if (!isEnabled()) return;
  posthog.capture(event, properties);
}

/**
 * Identidade pedida antes do `init`. O efeito que identifica o usuário mora
 * abaixo do provider na árvore, e o React roda efeito de filho antes do de pai —
 * sem essa fila, a primeira identificação de cada sessão se perderia.
 */
let pendingIdentity: { id: string; properties?: Record<string, unknown> } | null =
  null;

export function identifyUser(
  id: string,
  properties?: Record<string, unknown>,
): void {
  if (typeof window === "undefined") return;

  if (!isEnabled()) {
    pendingIdentity = { id, properties };
    return;
  }

  posthog.identify(id, properties);
}

/** Chamado pelo provider logo depois do `init`, para esvaziar a fila. */
export function flushPendingIdentity(): void {
  if (!pendingIdentity || !isEnabled()) return;

  posthog.identify(pendingIdentity.id, pendingIdentity.properties);
  pendingIdentity = null;
}

export function resetIdentity(): void {
  pendingIdentity = null;
  if (!isEnabled()) return;
  posthog.reset();
}
